<!--领队报名-->
<template>
  <div class="already-bmxx-page">
    <!-- 顶部导航 -->
    <top-item-com active="1" :ssid="ssid"></top-item-com>

    <!-- 比赛标题 -->
    <div class="page-header">
      <h2>{{ ssInfo.ssMc }}</h2>
    </div>

    <!-- 标签页 -->
    <van-tabs v-model="active" @change="onTabClick" class="custom-tabs">
      <van-tab>
        <template #title>
          <div class="tab-title">
            <van-icon name="gold-coin-o" />
            <span>报名数据</span>
          </div>
        </template>
      </van-tab>
      <van-tab>
        <template #title>
          <div class="tab-title">
            <van-icon name="underway" />
            <span>退费完成</span>
          </div>
        </template>
      </van-tab>
    </van-tabs>

    <!-- 报名数据标签页 -->
    <div v-if="active === 0" class="tab-content">
      <!-- 领队报名信息 -->
      <div>
        <report-ld-dw
          :ssid="ssid"
          :isShowSsmc="false"
          :ssIsBm="SSISBM"
        ></report-ld-dw>
      </div>

      <!-- 搜索栏 -->
      <div class="search-bar">
        <van-field
          v-model="ryInfo"
          left-icon="search"
          clearable
          placeholder="搜索人员或队伍"
        >
          <template #button>
            <van-button size="small" type="primary" @click="searchHandler">
              搜索
            </van-button>
          </template>
        </van-field>
      </div>

      <!-- 商城广告 -->
      <div
        v-if="ssInfo.createRybh === 'ZHTY'"
        class="shop-banner"
        @click="toXywlAdUrl"
      >
        <img
          src="https://www.ptty.com.cn/wap/xywlbsyqShopYhq.jpg"
          alt="商城购买"
        />
      </div>

      <!-- 已报名项目列表 -->
      <div class="registration-section">
        <div class="section-header">
          <van-icon name="checked" />
          <span>已报名项目</span>
          <span class="badge">{{ filteredYBMRYLIST.length }}</span>
        </div>

        <!-- 项目筛选菜单 -->
        <div class="filter-menu">
          <div
            v-for="option in filterOptions"
            :key="option.value"
            class="filter-item"
            :class="{ active: selectedFilter === option.value }"
            @click="selectedFilter = option.value"
          >
            {{ option.label }}
          </div>
        </div>

        <div v-if="filteredYBMRYLIST.length === 0" class="empty-state">
          <van-empty description="暂无报名项目" />
        </div>

        <div
          v-for="(item, index) in filteredYBMRYLIST"
          :key="index"
          class="registration-card"
        >
          <!-- 项目头部 -->
          <div class="card-header" :class="'header-' + getMatchType(item)">
            <div class="project-name">
              <van-icon :name="getMatchTypeIcon(item)" class="header-icon" />
              <span class="project-title">{{ item.XMJC }}</span>
              <span class="match-type-badge">{{
                getMatchTypeLabel(item)
              }}</span>
            </div>
            <div class="project-type">{{ item.SSLXMC }}</div>
          </div>

          <!-- 参赛人员 -->
          <div class="participants">
            <div class="participant-item">
              <img :src="item.TXURL1" :alt="item.RYXM1" />
              <div class="participant-info">
                <div class="team-name">{{ item.DWQC1 }}</div>
                <div class="person-name">
                  {{ item.RYXM1 }}
                  <span v-if="item.XB1 === 'M'" class="gender">（男）</span>
                  <span v-else-if="item.XB1 === 'W'" class="gender"
                    >（女）</span
                  >
                </div>
              </div>
            </div>

            <div v-if="item.RYXM2.length > 0" class="participant-item">
              <img :src="item.TXURL2" :alt="item.RYXM2" />
              <div class="participant-info">
                <div class="team-name">{{ item.DWQC2 }}</div>
                <div class="person-name">
                  {{ item.RYXM2 }}
                  <span v-if="item.XB2 === 'M'" class="gender">（男）</span>
                  <span v-else-if="item.XB2 === 'W'" class="gender"
                    >（女）</span
                  >
                </div>
              </div>
            </div>

            <div v-if="item.RYXM_FIN.length > 0" class="participant-item">
              <img :src="item.TXURL_FIN" :alt="item.RYXM_FIN" />
              <div class="participant-info">
                <div class="team-name">{{ item.DWQC_FIN }}</div>
                <div class="person-name">
                  {{ item.RYXM_FIN }}
                  <span v-if="item.XB_FIN === 'M'" class="gender">（男）</span>
                  <span v-else-if="item.XB_FIN === 'W'" class="gender"
                    >（女）</span
                  >
                </div>
              </div>
            </div>
          </div>

          <!-- 优惠信息 -->
          <div
            v-if="
              item.TEAMBMISYH === '1' &&
                (item.SSLX.substr(1, 2) === 'S'
                  ? item.SYHJE - 0 > 0
                  : item.SSLX.substr(1, 2) === 'D'
                  ? item.DYHJE > 0
                  : false) &&
                item.LDTEL.length > 0
            "
            class="discount-info"
          >
            <van-icon name="gift-o" />
            <span>
              成员达到{{ item.TEAMYHRS }}人可享受每人优惠{{
                item.SSLX.substr(1, 2) === "S" ? item.SYHJE : item.DYHJE
              }}元
            </span>
          </div>

          <!-- 警告信息 -->
          <div
            v-if="
              item.TEAMBMISYH === '1' &&
                (item.SSLX.substr(1, 2) === 'S'
                  ? item.SYHJE - 0 > 0
                  : item.SSLX.substr(1, 2) === 'D'
                  ? item.DYHJE > 0
                  : false) &&
                item.LDTEL.length > 0 &&
                item.ISZF !== '1' &&
                item.ISSF === '1' &&
                item.DWRS - 0 < item.TEAMYHRS
            "
            class="warning-info"
          >
            <van-icon name="warning-o" />
            <span>
              成员数({{ item.DWRS }})未达到{{ item.TEAMYHRS }}人，暂无法享受优惠
            </span>
          </div>

          <!-- 订单信息 -->
          <div v-if="item.YHDDH.length > 0" class="order-info">
            <div class="order-info-row">
              <div class="order-info-item">
                <span class="order-label">
                  <van-icon name="orders-o" />
                  订单号
                </span>
                <span class="order-value">{{ item.YHDDH }}</span>
              </div>
              <div class="order-info-item">
                <span class="order-label">
                  <van-icon name="cash-back-record" />
                  金额
                </span>
                <span class="order-amount-value">¥{{ item.SJJE }}</span>
              </div>
            </div>
            <div
              v-if="SSISBM === 'Y' && (item.TFZT === '1' || item.TFZT === '2')"
              :class="{
                'refund-status-row': item.TFZT === '1',
                'refund-status-row-red': item.TFZT === '2'
              }"
            >
              <van-icon :name="item.TFZT === '1' ? 'passed' : 'clock-o'" />
              <span>{{ item.TFZT === "1" ? "已完成退费" : "退费审核中" }}</span>
            </div>
          </div>

          <!-- 操作按钮 -->
          <div class="card-actions">
            <van-button
              v-if="item.HAIBAOURL.length > 0"
              type="info"
              size="small"
              round
              @click="openHaiBaoModal(item.HAIBAOURL)"
            >
              我的海报
            </van-button>
            <van-button
              v-if="item.TFZT === '2' && BMISJS === '1' && SSISBM === 'Y'"
              type="warning"
              size="small"
              round
              @click="qxRefundHandler(item)"
            >
              取消退费
            </van-button>
            <van-button
              v-if="item.TFZT === '0' && BMISJS === '1' && SSISBM === 'Y'"
              type="danger"
              size="small"
              round
              @click="deleteRyxx(item)"
            >
              取消报名
            </van-button>
            <van-button
              v-if="
                SSISBM === 'Y' &&
                  item.ISPAYLINE === '1' &&
                  (item.ISSF === '1' || item.BMLX === 'GR') &&
                  item.ISZF !== '1' &&
                  item.ISSF === '1' &&
                  (item.SSLX.substr(1, 2) === 'T'
                    ? item.BMTYPE === 'DW' && item.ISLD === '1'
                    : true)
              "
              type="warning"
              size="small"
              round
              @click="toPay(item.XMNM, item.XMID)"
            >
              去支付
            </van-button>
            <van-button
              v-if="
                item.YHDDH.length > 0 &&
                  item.ISSF === '1' &&
                  item.ISZF === '1' &&
                  (item.SSLX.substr(1, 2) === 'T'
                    ? item.BMTYPE === 'DW' && item.ISLD === '1'
                    : true)
              "
              type="info"
              size="small"
              round
              @click="toPayRecord(item)"
            >
              缴费凭证
            </van-button>
            <van-button
              v-if="
                (item.BMTYPE === 'CY' &&
                  (item.ISSF !== '1' ? true : item.ISZF === '1')) ||
                  (item.SSLX.substr(1, 2) === 'T' && item.BMTYPE === 'CY')
              "
              type="primary"
              size="small"
              round
              @click="editorRyInfo(item)"
            >
              {{
                BMISJS === "1" && SSISBM === "Y" ? "编辑信息" : "查看报名信息"
              }}
            </van-button>
          </div>
        </div>
      </div>
    </div>

    <!-- 退费完成标签页 -->
    <div v-if="active === 1" class="tab-content">
      <div class="registration-section">
        <div class="section-header refund-header">
          <van-icon name="passed" class="header-icon" />
          <span class="header-title">退费订单</span>
          <span class="badge refund-badge">{{ REFUNDRYLIST.length }}</span>
        </div>

        <div v-if="REFUNDRYLIST.length === 0" class="empty-state">
          <van-empty description="暂无退费订单" />
        </div>

        <div
          v-for="(item, index) in REFUNDRYLIST"
          :key="index"
          class="registration-card refund-card"
        >
          <!-- 项目头部 -->
          <div class="card-header header-refund">
            <div class="header-left">
              <van-icon name="gold-coin-o" class="refund-icon" />
              <div class="project-info">
                <span class="project-title">{{ item.XMJC }}</span>
                <span class="project-type-badge">{{ item.SSLXMC }}</span>
              </div>
            </div>
            <div class="refund-status-tag">
              <van-icon name="success" />
              <span>已退费</span>
            </div>
          </div>

          <!-- 参赛人员信息 -->
          <div class="participants-section">
            <div class="section-label">
              <van-icon name="friends-o" />
              <span>参赛人员</span>
            </div>

            <div class="participant-list">
              <div class="participant-item">
                <div class="participant-avatar">
                  <van-icon name="user-o" />
                </div>
                <div class="participant-details">
                  <div class="participant-name">{{ item.RYXM1 }}</div>
                  <div class="participant-team">{{ item.DWQC1 }}</div>
                </div>
              </div>

              <div
                v-if="item.RYXM2 && item.RYXM2.length > 0"
                class="participant-item"
              >
                <div class="participant-avatar">
                  <van-icon name="user-o" />
                </div>
                <div class="participant-details">
                  <div class="participant-name">{{ item.RYXM2 }}</div>
                  <div class="participant-team">{{ item.DWQC2 }}</div>
                </div>
              </div>
            </div>
          </div>

          <!-- 退费信息 -->
          <div v-if="SSISBM === 'Y'" class="refund-info-section">
            <div
              class="refund-order-info"
              v-if="item.YHDDH && item.YHDDH.length > 0"
            >
              <van-icon name="orders-o" class="order-icon" />
              <span class="order-label">订单号：</span>
              <span class="order-number">{{ item.YHDDH }}</span>
            </div>

            <van-button
              type="info"
              size="small"
              round
              @click="toPayRecord(item)"
              class="refund-record-btn"
            >
              <van-icon name="records" />
              查看退费记录
            </van-button>
          </div>
        </div>
      </div>
    </div>

    <div style="height: 100px;"></div>

    <!-- 支付组件 -->
    <enter-pay-com ref="paymodal" @child-event="mainData"></enter-pay-com>
    <pay-record-com ref="payrecord"></pay-record-com>
    <loading-com />
    <!-- 广告弹出位 -->

    <!-- :show="
        isAdTcc &&
          filteredYBMRYLIST !== undefined &&
          filteredYBMRYLIST.length > 0 &&
          filteredYBMRYLIST[0].HAIBAOURL !== undefined &&
          filteredYBMRYLIST[0].HAIBAOURL.length > 0
      " -->
    <van-overlay
      :show="
        isAdTcc &&
          filteredYBMRYLIST !== undefined &&
          filteredYBMRYLIST.length > 0 &&
          filteredYBMRYLIST[0].HAIBAOURL !== undefined &&
          filteredYBMRYLIST[0].HAIBAOURL.length > 0
      "
      @click="isAdTcc = false"
    >
      <div style="text-align: center;margin-top: 30%;">
        <div style="text-align: right;position: relative;">
          <span
            style="color: rgb(255, 255, 255);text-align: center;position: absolute;width: 55%;left: 19%;top: 7px;"
            >长按海报可保存到相册中</span
          >
          <img
            src="https://www.ptty.com.cn/wap/close.png"
            style="width: 36px;margin-right: 10%; margin-bottom: 15px;"
            @click="isAdTcc = false"
          />
        </div>
        <img
          v-if="
            isAdTcc &&
              filteredYBMRYLIST &&
              filteredYBMRYLIST.length > 0 &&
              filteredYBMRYLIST[0].HAIBAOURL &&
              filteredYBMRYLIST[0].HAIBAOURL.length > 0
          "
          :src="filteredYBMRYLIST[0].HAIBAOURL"
          style="border-radius: 6px;width: 80%;"
        />
        <div v-if="false">
          <van-button round style="width:50%;margin-top:15px;" @click="toAd('')"
            >查看详情</van-button
          >
        </div>
      </div>
    </van-overlay>

    <!-- 海报查询  开始 -->
    <van-overlay :show="hbQuery" @click="hbQuery = false">
      <div style="text-align: center;margin-top: 30%;">
        <div style="text-align: right;position: relative;">
          <span
            style="color: rgb(255, 255, 255);text-align: center;position: absolute;width: 55%;left: 19%;top: 7px;"
            >长按海报可保存到相册中</span
          >
          <img
            src="https://www.ptty.com.cn/wap/close.png"
            style="width: 36px;margin-right: 10%; margin-bottom: 15px;"
            @click="hbQuery = false"
          />
        </div>
        <img :src="haiBaoUrl" style="border-radius: 6px;width: 80%;" />
      </div>
    </van-overlay>
  </div>
</template>

<script>
import LoadingCom from "../commonCom/LoadingCom.vue";
import ReportLdDw from "../commonCom/ReportLdDw.vue";
import EnterPayCom from "../commonCom/EnterPayCom.vue";
import PayRecordCom from "../commonCom/PayRecordCom.vue";
import TopItemCom from "../commonCom/TopItemCom.vue";

export default {
  name: "AlreadyBmxx",
  components: { LoadingCom, ReportLdDw, EnterPayCom, PayRecordCom, TopItemCom },
  data() {
    return {
      isAdTcc: true,
      hbQuery: false,
      haiBaoUrl: "",
      isPay: false,
      utilPost: "",
      ssid: "",
      op: "wapGL",
      SSMC: "",
      YBMRYLIST: [],
      SSLX: "",
      requestXmnm: "",
      requestXmid: "",
      czlx: "",
      ryInfo: "",
      BMISJS: "0",
      SSISBM: "N",
      active: 0,
      REFUNDRYLIST: [],
      routeValue: "",
      ssInfo: {},
      selectedFilter: "all",
      filterOptions: [
        { label: "全部", value: "all" },
        { label: "单打", value: "singles" },
        { label: "双打", value: "doubles" },
        { label: "3v3", value: "team" },
        { label: "团体", value: "group" },
        { label: "团体成员", value: "group-member" }
      ]
    };
  },
  created() {
    this.utilPost = this.$util.handler;
    this.ssid = this.$route.query.ssid;
    this.requestXmnm = this.$route.query.requestXmnm;
    this.requestXmid = this.$route.query.requestXmid;
    this.czlx = this.$route.query.czlx;
    if (
      this.requestXmnm !== undefined &&
      this.requestXmnm !== null &&
      this.requestXmnm !== "" &&
      this.requestXmnm.length > 0
    ) {
      if (this.requestXmnm.indexOf("XMNM") === -1) {
        this.requestXmnm = "";
      }
    } else {
      this.requestXmnm = "";
    }
  },
  mounted() {
    var openIdEn = localStorage.getItem("openIdEn");
    if (openIdEn === undefined || openIdEn === null || openIdEn.length === 0) {
      this.utilPost.getOpenId(function(openId) {});
    }
    this.onTabClick();
    this.getSsInfo();
    this.getIsBmLoad();
  },
  computed: {
    filteredYBMRYLIST() {
      if (this.selectedFilter === "all") {
        return this.YBMRYLIST;
      }
      return this.YBMRYLIST.filter(
        item => this.getMatchType(item) === this.selectedFilter
      );
    }
  },
  methods: {
    openHaiBaoModal(haiBaoUrl) {
      this.hbQuery = true;
      this.haiBaoUrl = haiBaoUrl;
    },
    toXywlAdUrl() {
      window.location.href = "https://d.weimob.com/d/1_11_vcn8br";
      return;
    },
    getSsInfo() {
      var busData = {};
      var paramData = {
        headerData: {
          ssid: this.ssid,
          op: this.op,
          methodName: "getSsInfo"
        },
        busData: busData
      };
      this.utilPost.paramData = paramData;
      this.utilPost.sendPost().then(data => {
        if (!data.isSuccess) {
          alert(data.msg);
          return;
        }
        this.ssInfo = data.content;
      });
    },
    onTabClick() {
      if (this.active === 0) {
        this.mainData();
      } else if (this.active === 1) {
        this.refundData();
      }
    },
    refundData() {
      var paramData = {
        headerData: {
          ssid: this.ssid,
          op: this.op,
          methodName: "refundData"
        },
        busData: {}
      };
      this.utilPost.paramData = paramData;
      this.utilPost.sendPost().then(data => {
        if (!data.isSuccess) {
          alert(data.msg);
          return;
        }
        this.REFUNDRYLIST = data.content;
      });
    },
    getIsBmLoad() {
      var busData = {};
      var paramData = {
        headerData: {
          ssid: this.ssid,
          op: "wapGL",
          methodName: "checkIsBm"
        },
        busData: busData
      };
      this.utilPost.paramData = paramData;
      this.utilPost.sendPost().then(data => {
        if (!data.isSuccess) {
          alert(data.msg);
          return;
        }
        this.SSISBM = data.content;
      });
    },
    mainData() {
      var busData = {
        ryInfo: this.ryInfo
      };
      var paramData = {
        headerData: {
          ssid: this.ssid,
          op: this.op,
          methodName: "alreadyBmxx"
        },
        busData: busData
      };
      this.utilPost.paramData = paramData;
      this.utilPost.sendPost().then(data => {
        if (!data.isSuccess) {
          alert(data.msg);
          return;
        }
        this.YBMRYLIST = data.content.YBMRYLIST;
        this.BMISJS = data.content.BMISJS;
        if (this.requestXmnm.indexOf("XMNM") > -1) {
          if (this.czlx === "ADD") {
            var isToPay = false;
            for (var i = 0; i < this.YBMRYLIST.length; i++) {
              var resXMNM = this.YBMRYLIST[i].XMNM;
              var item = this.YBMRYLIST[i];
              if (this.requestXmnm === resXMNM) {
                if (item.TEAMBMISYH === "1") {
                  isToPay =
                    item.SSLX.substr(1, 2) === "S"
                      ? item.SYHJE - 0 > 0
                        ? item.LDTEL.length === 0
                          ? true
                          : item.DWRS - 0 >= item.TEAMYHRS &&
                            item.ISLDUIS === "1"
                        : true
                      : item.SSLX.substr(1, 2) === "D"
                      ? item.DYHJE > 0
                        ? item.LDTEL.length === 0
                          ? true
                          : item.DWRS - 0 >= item.TEAMYHRS &&
                            item.ISLDUIS === "1"
                        : true
                      : true;
                } else {
                  isToPay = true;
                }
              }
            }
            if (isToPay) {
              this.toPay(this.requestXmnm, this.requestXmid);
            }
          }
        }
      });
    },
    editorRyInfo(rowItem) {
      if (rowItem.BMLX === "GR") {
        var XMID = rowItem.XMID;
        this.$router.push({
          path: "/addRyInfo",
          query: {
            ssid: this.ssid,
            xmid: XMID,
            bmLx: "GR",
            dwid: "",
            czlx: "UPT",
            ryid1Param: rowItem.RYID1,
            ryid2Param: rowItem.RYID2,
            ryid3Param: rowItem.RYID_FIN,
            yhddh: rowItem.YHDDH
          }
        });
      } else {
        var XMID = rowItem.XMID;
        this.$router.push({
          path: "/addRyInfo",
          query: {
            ssid: this.ssid,
            xmid: XMID,
            bmLx:
              rowItem.SSLX.substr(1, 2) === "T" && rowItem.BMTYPE === "CY"
                ? "TEAM"
                : "GR",
            dwid: rowItem.DWID1,
            czlx: "UPT",
            ryid1Param: rowItem.RYID1,
            ryid2Param: rowItem.RYID2,
            ryid3Param: rowItem.RYID_FIN,
            yhddh: rowItem.YHDDH
          }
        });
      }
    },
    qxRefundHandler(itemRow) {
      var msg = "是否取消退费?";
      if (!confirm(msg)) {
        return;
      }

      var busData = {
        YHDDH: itemRow.YHDDH
      };
      var paramData = {
        headerData: {
          ssid: this.ssid,
          op: "wapGl",
          methodName: "qxRefundHandler"
        },
        busData: busData
      };
      this.utilPost.paramData = paramData;
      this.utilPost.sendPost().then(data => {
        if (data.isSuccess) {
          this.$notify({
            type: "success",
            message: data.msg,
            duration: 6000
          });
          this.mainData();
        } else {
          this.$notify({
            type: "danger",
            message: data.msg,
            duration: 6000
          });
        }
      });
    },
    deleteRyxx(itemRow) {
      var msg = "是否取消报名?";
      if (itemRow.BMTYPE === "DW") {
        msg =
          "您是否取消整支队伍报名？如果如您确认，对下所有的团体成员将会被一起删除！";
      }
      if (!confirm(msg)) {
        return;
      }
      var YHDDH = "";
      if (itemRow.BMTYPE === "CY" && itemRow.SSLX.substr(1, 2) === "T") {
        YHDDH = "NOYHDDH";
      } else {
        YHDDH = itemRow.YHDDH;
      }
      var busData = {
        XMID: itemRow.XMID,
        RYID1: itemRow.RYID1,
        RYID2: itemRow.RYID2,
        RYID3: itemRow.RYID_FIN,
        BMTYPE: itemRow.BMTYPE,
        YHDDH: YHDDH
      };
      var paramData = {
        headerData: {
          ssid: this.ssid,
          op: "payGl",
          methodName: "removeBmxxAndTf"
        },
        busData: busData
      };
      this.utilPost.paramData = paramData;
      this.utilPost.sendPost().then(data => {
        if (data.isSuccess) {
          this.$notify({
            type: "success",
            message: data.msg,
            duration: 6000
          });
          this.mainData();
        } else {
          this.$notify({
            type: "danger",
            message: data.msg,
            duration: 6000
          });
        }
      });
    },
    searchHandler() {
      this.czlx = "";
      this.mainData();
    },
    toPay(XMNM, XMID) {
      var xmnms = [];
      var xmnmItem = {
        XMNM: XMNM
      };
      xmnms.push(xmnmItem);
      var paramS = {
        XMNMS: xmnms,
        XMID: XMID
      };
      this.$refs.paymodal.setXmnmArray(paramS, this.ssid);
      this.$refs.paymodal.openPayModal();
    },
    toPayRecord(item) {
      var paramS = {
        YHDDH: item.YHDDH,
        XMID: item.XMID
      };
      this.$refs.payrecord.setData(paramS, this.ssid);
      this.$refs.payrecord.openPayModal();
    },
    getMatchType(item) {
      // Check if it's a group member
      if (item.BMTYPE === "CY" && item.SSLX.substr(1, 2) === "T") {
        return "group-member";
      }

      // Check if it's a group (team lead)
      if (item.BMTYPE === "DW" && item.SSLX.substr(1, 2) === "T") {
        return "group";
      }

      // Count participants for singles/doubles/3v3
      let count = 0;
      if (item.RYXM1 && item.RYXM1.length > 0) count++;
      if (item.RYXM2 && item.RYXM2.length > 0) count++;
      if (item.RYXM_FIN && item.RYXM_FIN.length > 0) count++;

      if (count === 1) return "singles";
      if (count === 2) return "doubles";
      if (count === 3) return "team";
      return "singles";
    },
    getMatchTypeLabel(item) {
      // Check if it's a group member
      if (item.BMTYPE === "CY" && item.SSLX.substr(1, 2) === "T") {
        return "团体成员";
      }

      // Check if it's a group (team lead)
      if (item.BMTYPE === "DW" && item.SSLX.substr(1, 2) === "T") {
        return "团体";
      }

      // Count participants for singles/doubles/3v3
      let count = 0;
      if (item.RYXM1 && item.RYXM1.length > 0) count++;
      if (item.RYXM2 && item.RYXM2.length > 0) count++;
      if (item.RYXM_FIN && item.RYXM_FIN.length > 0) count++;

      if (count === 1) return "单打";
      if (count === 2) return "双打";
      if (count === 3) return "3v3";
      return "单打";
    },
    getMatchTypeIcon(item) {
      const type = this.getMatchType(item);
      const icons = {
        singles: "contact",
        doubles: "friends-o",
        team: "gold-coin-o",
        group: "cluster",
        "group-member": "user-circle-o"
      };
      return icons[type] || "contact";
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.already-bmxx-page {
  min-height: 100vh;
  background: #f5f6fa;
}

/* 页面头部 */
.page-header {
  background: linear-gradient(135deg, #185f9b 0%, #1a6ba8 100%);
  color: #fff;
  padding: 0.8rem 1rem;
  text-align: center;
}

.page-header h2 {
  margin: 0;
  font-size: 1.125rem;
  font-weight: 700;
  letter-spacing: 0.5px;
}

/* 标签页 */
/deep/ .custom-tabs {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

/deep/ .custom-tabs .van-tabs__line {
  background: linear-gradient(135deg, #185f9b 0%, #1a6ba8 100%);
}

/deep/ .custom-tabs .van-tab--active {
  color: #185f9b;
  font-weight: 600;
}

.tab-title {
  display: flex;
  align-items: center;
  gap: 0.375rem;
  font-size: 0.875rem;
}

/* 标签页内容 */
.tab-content {
  padding: 0.75rem 0;
}

/* 搜索栏 */
.search-bar {
  padding: 0.5rem 0.75rem;
}

/deep/ .search-bar .van-field {
  background: #fff;
  border-radius: 0.5rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  height: 2.7rem;
  display: flex;
  align-items: center;
  padding-right: 0px;
}

/deep/ .search-bar .van-field__left-icon {
  color: #185f9b;
  display: flex;
  align-items: center;
  justify-content: center;
}

/deep/ .search-bar .van-field__body {
  display: flex;
  align-items: center;
}

/deep/ .search-bar .van-field__control {
  display: flex;
  align-items: center;
}

/deep/ .search-bar .van-button--primary {
  background: linear-gradient(135deg, #185f9b 0%, #1a6ba8 100%);
  border: none;
  margin-left: auto;
  height: 3rem;
  width: 3.6rem;
}

/* 商城广告 */
.shop-banner {
  padding: 1rem 0.75rem;
  cursor: pointer;
  transition: transform 0.3s ease;
}

.shop-banner:active {
  transform: scale(0.98);
}

.shop-banner img {
  width: 100%;
  border-radius: 0.75rem;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
}

/* 领队信息 */
.leader-info-section {
  padding-top: 0.3rem;
  padding-bottom: 0.3rem;
  background: #f6f8fa;
  margin: 0.5rem 0.75rem;
  border-radius: 0.75rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

/* 报名列表 */
.registration-section {
  padding: 0.75rem;
}

.section-header {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 1rem 0.75rem;
  font-size: 1rem;
  font-weight: 700;
  color: #333;
  background: #fff;
  border-radius: 0.75rem;
  margin-bottom: 0.75rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.section-header .van-icon {
  color: #185f9b;
  font-size: 1.25rem;
}

.badge {
  margin-left: auto;
  background: linear-gradient(135deg, #185f9b 0%, #1a6ba8 100%);
  color: #fff;
  padding: 0.25rem 0.75rem;
  border-radius: 1.25rem;
  font-size: 0.75rem;
  font-weight: 700;
}

/* 筛选菜单 */
.filter-menu {
  display: flex;
  gap: 0.5rem;
  padding: 0.75rem;
  background: #fff;
  border-radius: 0.75rem;
  margin-bottom: 0.75rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

.filter-item {
  flex-shrink: 0;
  padding: 0.5rem 1rem;
  background: #f0f0f0;
  border-radius: 1.25rem;
  font-size: 0.8125rem;
  font-weight: 600;
  color: #666;
  cursor: pointer;
  transition: all 0.3s ease;
  white-space: nowrap;
}

.filter-item:hover {
  background: #e0e0e0;
}

.filter-item.active {
  background: linear-gradient(135deg, #185f9b 0%, #1a6ba8 100%);
  color: #fff;
}

/* 空状态 */
.empty-state {
  padding: 2.5rem 1.25rem;
  text-align: center;
}

/* 报名卡片 */
.registration-card {
  background: #fff;
  border-radius: 0.75rem;
  padding: 0.35rem;
  margin-bottom: 0.75rem;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  border: 2px solid #e9ecef;
  transition: all 0.3s ease;
  animation: slideInUp 0.4s ease;
}

@keyframes slideInUp {
  from {
    opacity: 0;
    transform: translateY(1.25rem);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.registration-card:hover {
  box-shadow: 0 6px 24px rgba(24, 95, 155, 0.15);
  border-color: rgba(24, 95, 155, 0.3);
}

.registration-card.refund-card {
  background: linear-gradient(135deg, #f0f7ff 0%, #e6f3ff 100%);
  border: 2px solid #185f9b;
  box-shadow: 0 4px 12px rgba(24, 95, 155, 0.15);
}

/* 退费订单头部 */
.refund-header {
  background: linear-gradient(135deg, #185f9b 0%, #1a6ba8 100%);
  color: #fff;
  padding: 0.875rem 1rem;
  border-radius: 0.75rem;
  margin-bottom: 1rem;
}

.refund-header .header-icon {
  color: #fff;
  font-size: 1.25rem;
}

.refund-header .header-title {
  color: #fff;
}

.refund-badge {
  background: rgba(255, 255, 255, 0.3);
  color: #fff;
  border: 1px solid rgba(255, 255, 255, 0.5);
}

/* 退费卡片头部 */
.card-header.header-refund {
  background: linear-gradient(135deg, #185f9b 0%, #1a6ba8 100%);
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem;
  border-radius: 0.75rem;
  margin-bottom: 1rem;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  flex: 1;
}

.refund-icon {
  font-size: 1.75rem;
  color: #fff;
  flex-shrink: 0;
}

.project-info {
  display: flex;
  flex-direction: column;
  gap: 0.375rem;
}

.project-title {
  font-size: 1rem;
  font-weight: 700;
  color: #fff;
}

.project-type-badge {
  display: inline-block;
  padding: 0.125rem 0.5rem;
  background: rgba(255, 255, 255, 0.25);
  border-radius: 0.75rem;
  font-size: 0.75rem;
  color: #fff;
  font-weight: 600;
  width: fit-content;
}

.refund-status-tag {
  display: flex;
  align-items: center;
  gap: 0.25rem;
  padding: 0.375rem 0.75rem;
  background: rgba(255, 255, 255, 0.9);
  border-radius: 1rem;
  color: #10b981;
  font-size: 0.8125rem;
  font-weight: 700;
  flex-shrink: 0;
}

.refund-status-tag .van-icon {
  font-size: 1rem;
}

/* 参赛人员区域 */
.participants-section {
  padding: 0.75rem;
  background: rgba(255, 255, 255, 0.6);
  border-radius: 0.75rem;
  margin-bottom: 0.75rem;
}

.section-label {
  display: flex;
  align-items: center;
  gap: 0.375rem;
  margin-bottom: 0.75rem;
  color: #185f9b;
  font-weight: 600;
  font-size: 0.875rem;
}

.section-label .van-icon {
  font-size: 1rem;
}

.participant-list {
  display: flex;
  flex-direction: column;
  gap: 0.625rem;
}

.participant-item {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.625rem;
  background: #fff;
  border-radius: 0.5rem;
  border: 1px solid #b3d9f2;
}

.participant-avatar {
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 50%;
  background: linear-gradient(135deg, #185f9b 0%, #1a6ba8 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.participant-avatar .van-icon {
  font-size: 1.25rem;
  color: #fff;
}

.participant-details {
  flex: 1;
  min-width: 0;
}

.participant-name {
  font-size: 0.9375rem;
  font-weight: 700;
  color: #185f9b;
  margin-bottom: 0.25rem;
}

.participant-team {
  font-size: 0.8125rem;
  color: #1a6ba8;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* 退费信息区域 */
.refund-info-section {
  padding: 0.75rem;
  background: rgba(255, 255, 255, 0.6);
  border-radius: 0.75rem;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.refund-order-info {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.625rem;
  background: #fff;
  border-radius: 0.5rem;
  border: 1px solid #b3d9f2;
}

.order-icon {
  font-size: 1.125rem;
  color: #185f9b;
  flex-shrink: 0;
}

.order-label {
  font-size: 0.8125rem;
  color: #185f9b;
  font-weight: 500;
}

.order-number {
  flex: 1;
  font-size: 0.8125rem;
  color: #1a6ba8;
  font-weight: 600;
  font-family: monospace;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.refund-record-btn {
  background: linear-gradient(135deg, #185f9b 0%, #1a6ba8 100%);
  border: none;
  color: #fff;
  font-weight: 600;
  box-shadow: 0 2px 8px rgba(24, 95, 155, 0.3);

  .van-icon {
    margin-right: 0.25rem;
  }
}

/* 卡片头部 */
.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.75rem;
  border-radius: 0.5rem;
  margin-bottom: 0.75rem;
  color: #fff;
  font-weight: 600;
}

.card-header.header-singles {
  background: linear-gradient(135deg, #185f9b 0%, #1a6ba8 100%);
}

.card-header.header-doubles {
  background: linear-gradient(135deg, #185f9b 0%, #1a6ba8 100%);
}

.card-header.header-team {
  background: linear-gradient(135deg, #185f9b 0%, #1a6ba8 100%);
}

.card-header.header-group {
  background: linear-gradient(135deg, #185f9b 0%, #1a6ba8 100%);
}

.card-header.header-group-member {
  background: linear-gradient(135deg, #185f9b 0%, #1a6ba8 100%);
}

.header-icon {
  font-size: 1.5rem;
  margin-right: 0.5rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1.75rem;
  height: 1.75rem;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 0.5rem;
  flex-shrink: 0;
}

.match-type-badge {
  display: inline-block;
  background: rgba(255, 255, 255, 0.3);
  padding: 0.25rem 0.5rem;
  border-radius: 0.25rem;
  font-size: 0.75rem;
  font-weight: 700;
}

.project-name {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.project-title {
  font-size: 1rem;
  font-weight: 700;
  color: #fff;
}

.tag {
  background: rgba(255, 255, 255, 0.3);
  color: #fff;
  padding: 0.125rem 0.5rem;
  border-radius: 0.25rem;
  font-size: 0.75rem;
  font-weight: 600;
}

.project-type {
  font-size: 0.875rem;
  color: #fff;
  font-weight: 600;
}

/* 参赛人员 */
.participants {
  margin-bottom: 0.75rem;
}

.participant-item {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.75rem 0;
  border-top: 1px solid #e9ecef;
  padding-left: 13px;
}

.participant-item:first-child {
  border-top: none;
  padding-top: 13px;
  padding-left: 13px;
}

.participant-item img {
  width: 3rem;
  height: 3rem;
  border-radius: 50%;
  border: 3px solid #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  flex-shrink: 0;
}

.participant-info {
  flex: 1;
}

.team-name {
  font-size: 0.8125rem;
  color: #999;
  margin-bottom: 0.25rem;
}

.person-name {
  font-size: 0.875rem;
  font-weight: 600;
  color: #333;
}

.gender {
  margin-left: 0.25rem;
  font-size: 0.75rem;
}

/* 优惠信息 */
.discount-info {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem;
  background: linear-gradient(135deg, #f6ffed 0%, #f0ffe6 100%);
  border: 1px solid #b7eb8f;
  border-radius: 0.5rem;
  color: #52c41a;
  font-size: 0.8125rem;
  margin-bottom: 0.75rem;
}

.discount-info .van-icon {
  font-size: 1rem;
  flex-shrink: 0;
}

/* 警告信息 */
.warning-info {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem;
  background: linear-gradient(135deg, #fff7e6 0%, #ffe7ba 100%);
  border: 1px solid #ffd591;
  border-radius: 0.5rem;
  color: #ff9800;
  font-size: 0.8125rem;
  margin-bottom: 0.75rem;
}

.warning-info .van-icon {
  font-size: 1rem;
  flex-shrink: 0;
}

/* 订单信息 */
.order-info {
  padding: 0.75rem;
  background: linear-gradient(135deg, #f0f9ff 0%, #e6f7ff 100%);
  border: 1px solid #91d5ff;
  border-radius: 0.5rem;
  margin-bottom: 0.75rem;
}

.order-info-row {
  display: flex;
  gap: 1rem;
  margin-bottom: 0.5rem;
}

.order-info-item {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.order-label {
  display: flex;
  align-items: center;
  gap: 0.25rem;
  font-size: 0.75rem;
  color: #999;
  font-weight: 600;
}

.order-label .van-icon {
  font-size: 0.875rem;
  color: #1890ff;
}

.order-value {
  font-size: 0.875rem;
  color: #333;
  font-weight: 600;
  word-break: break-all;
}

.order-amount-value {
  font-size: 1rem;
  color: #ff6b6b;
  font-weight: 700;
}

.refund-status-row {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem;
  background: rgba(82, 196, 26, 0.1);
  border-radius: 0.375rem;
  font-size: 0.8125rem;
  color: #52c41a;
  font-weight: 600;
}

.refund-status-row-red {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem;
  background: rgba(82, 196, 26, 0.1);
  border-radius: 0.375rem;
  font-size: 0.8125rem;
  color: #c80000;
  font-weight: 600;
}

.refund-status-row .van-icon {
  font-size: 1rem;
}

/* 卡片操作按钮 */
.card-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  padding-top: 0.75rem;
  border-top: 1px solid #e9ecef;
}

/deep/ .card-actions .van-button {
  flex: 1;
  min-width: 5rem;
  border-radius: 0.5rem;
  font-weight: 600;
}

/deep/ .van-button--primary {
  background: linear-gradient(135deg, #185f9b 0%, #1a6ba8 100%);
  border: none;
}

/deep/ .van-button--danger {
  background: linear-gradient(135deg, #ff4d4f 0%, #ff7875 100%);
  border: none;
}

/deep/ .van-button--warning {
  background: linear-gradient(135deg, #319e03 0%, #0831d5 100%);
  border: none;
}

/deep/ .van-button--info {
  background: linear-gradient(135deg, #1890ff 0%, #40a9ff 100%);
  border: none;
}

/* 退费信息 */
.refund-info {
  padding: 0.75rem;
  background: #f0f9ff;
  border-radius: 0.5rem;
  text-align: center;
}

.refund-status-badge {
  display: inline-block;
  background: linear-gradient(135deg, #52c41a 0%, #73d13d 100%);
  color: #fff;
  padding: 0.375rem 0.75rem;
  border-radius: 1.25rem;
  font-size: 0.8125rem;
  font-weight: 700;
  margin-bottom: 0.5rem;
}

.refund-order {
  font-size: 0.8125rem;
  color: #666;
  margin-bottom: 0.75rem;
}

/* 响应式 */
@media (max-width: 480px) {
  .page-header h2 {
    font-size: 1rem;
  }

  .section-header {
    font-size: 0.9375rem;
  }

  .project-title {
    font-size: 0.9375rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ReportXm/AlreadyBmxx.vue